import { Link } from "react-router-dom";
import { Phone } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { BUSINESS } from "@/data/site";

export const CTABand = ({
  eyebrow,
  heading,
  copy,
  primary = { label: "Schedule a Tour", to: "/contact?intent=tour", testid: "cta-schedule-tour" },
  secondary = { label: `Call ${BUSINESS.phone}`, href: BUSINESS.phoneHref, testid: "cta-call" },
  dark = true,
}) => {
  return (
    <section className={dark ? "bg-espresso text-ivory border-t-4 border-laurel" : "bg-cream text-charcoal border-t-4 border-sagelight"} data-testid="cta-band">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16 lg:py-20 text-center">
        <Reveal>
          {eyebrow && (
            <p className={`text-xs sm:text-sm uppercase tracking-[0.22em] font-semibold ${dark ? "text-gold" : "text-sage"}`}>
              {eyebrow}
            </p>
          )}
          <h2 className="mt-3 font-serif text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-balance">
            {heading}
          </h2>
          {copy && (
            <p className={`mt-4 text-base sm:text-lg leading-relaxed max-w-2xl mx-auto ${dark ? "text-ivory/75" : "text-warmgray"}`}>
              {copy}
            </p>
          )}
          <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
            {primary && (
              <Link
                to={primary.to}
                data-testid={primary.testid}
                className={`w-full sm:w-auto text-center font-semibold px-8 py-4 rounded-full transition-colors ${
                  dark
                    ? "bg-gold text-charcoal hover:bg-ivory"
                    : "bg-espresso text-ivory hover:bg-charcoal"
                }`}
              >
                {primary.label}
              </Link>
            )}
            {secondary &&
              secondary.href &&
              (secondary.href.startsWith("/") ? (
                <Link
                  to={secondary.href}
                  data-testid={secondary.testid}
                  className={`w-full sm:w-auto flex items-center justify-center gap-2 font-semibold px-8 py-4 rounded-full border transition-colors ${
                    dark
                      ? "border-ivory/40 text-ivory hover:border-gold hover:text-gold"
                      : "border-espresso text-espresso hover:bg-espresso hover:text-ivory"
                  }`}
                >
                  {secondary.label}
                </Link>
              ) : (
                <a
                  href={secondary.href}
                  data-testid={secondary.testid}
                  className={`w-full sm:w-auto flex items-center justify-center gap-2 font-semibold px-8 py-4 rounded-full border transition-colors ${
                    dark
                      ? "border-ivory/40 text-ivory hover:border-gold hover:text-gold"
                      : "border-espresso text-espresso hover:bg-espresso hover:text-ivory"
                  }`}
                >
                  {secondary.href.startsWith("tel:") && <Phone size={18} aria-hidden="true" />}
                  {secondary.label}
                </a>
              ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
